var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 4C18.4477 4 18 4.44772 18 5C18 5.55228 18.4477 6 19 6C19.5523 6 20 5.55228 20 5C20 4.44772 19.5523 4 19 4ZM16 5C16 3.34315 17.3431 2 19 2C20.6569 2 22 3.34315 22 5C22 6.30622 21.1652 7.41746 20 7.8293V16.1707C21.1652 16.5825 22 17.6938 22 19C22 20.6569 20.6569 22 19 22C17.3431 22 16 20.6569 16 19C16 18.9535 16.0011 18.9073 16.0031 18.8613L7.13219 15.1104C6.58846 15.6597 5.83397 16 5 16C3.34315 16 2 14.6569 2 13C2 11.3431 3.34315 10 5 10C5.71869 10 6.37835 10.2527 6.89497 10.6741L16.0575 5.58763C16.0198 5.3976 16 5.20111 16 5ZM7.93657 12.3834C7.97815 12.5824 8 12.7887 8 13C8 13.1011 7.995 13.2011 7.98522 13.2997L16.7564 17.0084C17.0901 16.6328 17.5166 16.3416 18 16.1707V7.82929C17.662 7.70982 17.3518 7.53148 17.0817 7.3066L7.93657 12.3834ZM18 19C18 18.4477 18.4477 18 19 18C19.5523 18 20 18.4477 20 19C20 19.5523 19.5523 20 19 20C18.4477 20 18 19.5523 18 19ZM4 13C4 12.4477 4.44772 12 5 12C5.55228 12 6 12.4477 6 13C6 13.5523 5.55228 14 5 14C4.44772 14 4 13.5523 4 13Z",
    fill: "#A1A8B3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/network.4f5d688f27f85f78beb39c3a1a9d305f.svg";
export { ForwardRef as ReactComponent };